import request from '@/utils/request';
import { endpoints, configurationEndpoint } from '@/constants/urls';

const configurations = (filter, page, pageSize) => {
  const params = {
    filter,
    page,
    pageSize,
  };

  return (
    request({
      url: endpoints.CONFIGURATIONS,
      params,
      method: 'GET',
    })
  );
};

const configuration = (code) => request({
  url: configurationEndpoint(code),
  method: 'GET',
});

const update = (code, value) => request({
  url: configurationEndpoint(code),
  data: { value },
  method: 'PUT',
});

const ConfigurationService = {
  configurations,
  configuration,
  update,
};

export default ConfigurationService;
